const useStella = () => {
  const stella = {
    YATO: {
      colors: {
        name: '#ff9e1f',
        nameBorder: '#fffccb',
      },
      imageURL: '/RT/Yato_RT_20-1.png',
      platformLink: 'https://chzzk.naver.com/e87999abca4fd0c3214e05ef414ce951',
    },
    ODANMING: {
      colors: {
        name: '#ff9e1f',
        nameBorder: '#fffccb',
      },
      imageURL: '/RT/Danming_RT_20.png',
      platformLink: 'https://chzzk.naver.com/f3b204dd3fd6925835ca1848cd4b6d3c'
    },
    HAMKUBBY: {
      colors: {
        name: '#ff9e1f',
        nameBorder: '#fffccb',
      },
      imageURL: '/RT/Kubby_RT_20.png',
      platformLink: 'https://chzzk.naver.com/9351fb8417f73405c84e0846409e3263'
    },
    YUNE: {
      colors: {
        name: '#ff9e1f',
        nameBorder: '#fffccb',
      },
      imageURL: '/RT/Kubby_RT_20.png',
      platformLink: 'https://chzzk.naver.com/9351fb8417f73405c84e0846409e3263'
    },
    DORI: {
      colors: {
        name: '#ff9e1f',
        nameBorder: '#fffccb',
      },
      imageURL: '/RT/Kubby_RT_20.png',
      platformLink: 'https://chzzk.naver.com/9351fb8417f73405c84e0846409e3263'
    },
    FUWA: {
      colors: {
        name: '#ff9e1f',
        nameBorder: '#fffccb',
      },
      imageURL: '/RT/Kubby_RT_20.png',
      platformLink: 'https://chzzk.naver.com/9351fb8417f73405c84e0846409e3263'
    },
    NIU: {
      colors: {
        name: '#ff9e1f',
        nameBorder: '#fffccb',
      },
      imageURL: '/RT/Kubby_RT_20.png',
      platformLink: 'https://chzzk.naver.com/9351fb8417f73405c84e0846409e3263'
    },
  };

  return { stella };
};

export default useStella;
